module.exports = __webpack_public_path__ + "static/img/file_swift.8fc92c10.png";